var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 199,
    viewBox: "0 0 207 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55151 60.2175C3.55151 48.0673 13.4012 38.2175 25.5515 38.2175L77.5235 38.2175V88.0119H25.5515C13.4013 88.0119 3.55151 78.1622 3.55151 66.0119L3.55151 60.2175Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.991 60.2175C203.991 48.0673 194.141 38.2175 181.991 38.2175L131.879 38.2175L131.879 88.0119L181.991 88.0119C194.141 88.0119 203.991 78.1622 203.991 66.0119L203.991 60.2175Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0776 3H171.564V78.2056C171.564 112.447 143.805 140.206 109.564 140.206H100.078C65.836 140.206 38.0776 112.447 38.0776 78.2056V3Z",
    fill: "#F9F9F9",
    stroke: "#4BDACC",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6711 191.224C53.6711 173.551 67.998 159.224 85.6711 159.224H121.68C139.354 159.224 153.68 173.551 153.68 191.224V196H53.6711V191.224Z",
    stroke: "#4BDACC",
    strokeWidth: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.3304204bd9de50d90c358f31fd3e29c1.svg";
export { ForwardRef as ReactComponent };